import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAuthConfig } from '@models';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthConfigService {
    private _endpoint = '/odata/Settings/UiPath.Server.Configuration.OData.GetAuthenticationSettings';

    constructor(
        protected _http: HttpClient,
    ) { }

    public get(): Observable<IAuthConfig> {
        return this._http.get<any>(this._endpoint)
            .pipe(
                map(data => MapperService.authSettingsMapper(data)),
            );
    }
}
